import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/yinghui_logo.png'
import _imports_1 from '@/assets/yinghui_text.png'
import _imports_2 from '@/assets/home/img_home_menu_phone.png'


const _withScopeId = n => (_pushScopeId("data-v-40d1734b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-menu-div" }
const _hoisted_2 = { class: "header-menu-div" }
const _hoisted_3 = { class: "header-menu-div" }
const _hoisted_4 = ["src"]

import {ref, onMounted, onBeforeUnmount} from 'vue';
import router from "@/router";
import {AppConfig} from "@/config";
import {isShowMenuPhone, isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const menuHome = ref(null);
const menuCredit = ref(null);
const menuAbout = ref(null);

const headerBackground = ref('rgba(255, 255, 255, 0.5)');
const handleScroll = () => {
  const scrollPosition = window.scrollY;
  const headerOpacity = Math.max(scrollPosition / 100, 0.5); // 最小透明度为0.5
  headerBackground.value = `rgba(255, 255, 255, ${headerOpacity})`;
};
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

const clearMenuSelection = () => {
  menuHome.value.style.color = '#2f2f2f'
  menuCredit.value.style.color = '#2f2f2f'
  menuAbout.value.style.color = '#2f2f2f'
};

const onHomeClick = () => {
  router.push("/")
  clearMenuSelection()
  menuHome.value.style.color = '#1b57ec'
  isShowMenuPhone.value = false
}

const onMenuClick = (event, route: string) => {
  clearMenuSelection()
  event.target.style.color = '#1b57ec'
  router.push(route)
}

const visiblePhoneMenu = () => {
  isShowMenuPhone.value = !isShowMenuPhone.value; // 切换 boolean 变量的值
}

const onQrCodeClick = () =>{
  isShowQrCodeDialog.value = true
}

const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "header",
    style: _normalizeStyle({ backgroundColor: headerBackground.value })
  }, [
    _createVNode(_component_el_row, {
      class: "header-menu hidden-md-and-down",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "header-menu-logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onHomeClick()))
          }),
          _createElementVNode("img", {
            src: _imports_1,
            class: "header-menu-logo-text margin-left-10 margin-top-5",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onHomeClick()))
          }),
          _createElementVNode("span", {
            ref_key: "menuHome",
            ref: menuHome,
            class: "header-menu-text margin-left-30",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onMenuClick($event, _unref(AppConfig).route_home)))
          }, "首页", 512),
          _createElementVNode("span", {
            ref_key: "menuCredit",
            ref: menuCredit,
            class: "header-menu-text margin-left-30",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onMenuClick($event, _unref(AppConfig).route_cpCredit)))
          }, "企业信用维护", 512),
          _createElementVNode("span", {
            ref_key: "menuAbout",
            ref: menuAbout,
            class: "header-menu-text margin-left-30",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onMenuClick($event, _unref(AppConfig).route_about)))
          }, "关于我们", 512),
          _createElementVNode("img", {
            src: _imports_2,
            class: "header-menu-img-phone margin-left-100",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onPhoneClick()))
          }),
          _createElementVNode("span", {
            class: "header-menu-text margin-left-10",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (onPhoneClick()))
          }, "13167540356"),
          _createElementVNode("span", {
            class: "header-menu-button margin-left-30",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (onQrCodeClick()))
          }, "扫码联系")
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "header-menu-phone hidden-md-and-up",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "header-menu-logo margin-left-20",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (onHomeClick()))
          }),
          _createElementVNode("img", {
            src: _imports_1,
            class: "header-menu-logo-text margin-left-10 margin-top-5",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (onHomeClick()))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(isShowMenuPhone) ? require('@/assets/img_phone_close.png') : require('@/assets/img_phone_menu.png'),
            class: "header-menu-phone-img margin-right-20",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (visiblePhoneMenu()))
          }, null, 8, _hoisted_4)
        ])
      ]),
      _: 1
    })
  ], 4))
}
}

})